import { UtenteService } from './../services/utente.service';
import { IUtente } from './../interfaces/IUtente';
import { IRuolo } from './../interfaces/IRuolo';
import { RuoloService } from './../services/ruolo.service';
import { IGruppo } from './../interfaces/IGruppo';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/api';
import { Loading } from '../utils/loading';
import { RequestBuilder } from '../classes/request-builder';
import { finalize } from 'rxjs/operators';
import { GruppoService } from '../services/gruppo.service';
import { AlertUtil } from '../utils/alert-util';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-utente-modal',
  templateUrl: './utente-modal.component.html',
  styleUrls: ['./utente-modal.component.css']
})
export class UtenteModalComponent implements OnInit {

  utenteForm: FormGroup
  utenteForUpdate: IUtente
  isUpdate: boolean = false

  gruppi: IGruppo[]
  selectedGruppo: IGruppo[]
  ruoli: IRuolo[]
  selectedRuolo: IRuolo

  payloadRuoli: any
  utenteObj: IUtente
  fromReferente: boolean

  constructor(private formBuilder: FormBuilder,
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private gruppoService: GruppoService,
    private ruoloService: RuoloService,
    private alertUtil: AlertUtil,
    private translate: TranslateService,
    private utenteService: UtenteService) {
    setTimeout(() => {
      this.getAllRuoli()
      this.getAllGruppi()
    }, 0);

    this.utenteForUpdate = this.config.data.utente
    this.isUpdate = this.utenteForUpdate ? true : false
    this.fromReferente = this.config.data.fromReferente ? true : false
    //build form group
    this.serForm();
  }

  private serForm() {
    this.setUtenteForm();
    if (this.isUpdate) {
      this.selectedRuolo = this.utenteForUpdate.Ruolo
      setTimeout(() => {
        this.getGruppiByRuolo(this.selectedRuolo)
      }, 0)
    }
  }

  private setUtenteForm() {
    if (this.fromReferente) {
      this.utenteForm = this.formBuilder.group({
        'Nome': [this.utenteForUpdate ? this.utenteForUpdate.Nome : '', Validators.required],
        'Cognome': [this.utenteForUpdate ? this.utenteForUpdate.Cognome : '', Validators.required],
        'Username': [{ value: this.utenteForUpdate ? this.utenteForUpdate.UserName : '', disabled: this.isUpdate }, Validators.required],
        'Email': [this.utenteForUpdate ? this.utenteForUpdate.Email : '', Validators.compose([Validators.required, Validators.email])]
      });
    } else {
      this.utenteForm = this.formBuilder.group({
        'Nome': [this.utenteForUpdate ? this.utenteForUpdate.Nome : '', Validators.required],
        'Cognome': [this.utenteForUpdate ? this.utenteForUpdate.Cognome : '', Validators.required],
        'Username': [{ value: this.utenteForUpdate ? this.utenteForUpdate.UserName : '', disabled: this.isUpdate }, Validators.required],
        'Email': [this.utenteForUpdate ? this.utenteForUpdate.Email : '', Validators.compose([Validators.required, Validators.email])],
        'Gruppo': [this.utenteForUpdate ? this.utenteForUpdate.Gruppi : ''],
        'Ruolo': [this.utenteForUpdate ? this.utenteForUpdate.Ruolo : '', Validators.required]
      });
    }
  }

  ngOnInit() {
  }

  // convenience getter for easy access to form fields
  get form() { return this.utenteForm.controls; }

  onSubmit() {
    if (this.utenteForm.valid) {
      //retrieve values from form
      let Nome = this.utenteForm.controls['Nome'].value
      let Cognome = this.utenteForm.controls['Cognome'].value
      let Username = this.utenteForm.controls['Username'].value
      let Email = this.utenteForm.controls['Email'].value
      let Ruolo: any = {}
      let listIdGruppi: any[] = []
      if (!this.fromReferente) {
        Ruolo = this.utenteForm.controls['Ruolo'].value
        if (this.isUpdate) {
          this.utenteForUpdate.Gruppi = []
          this.utenteForUpdate.GruppiAssociati = ''
        }
        let ListGruppi = this.utenteForm.controls['Gruppo'].value
        listIdGruppi = this.getListaId(ListGruppi)
      } else {
        Ruolo = {
          Ruolo: "Referente"
        }
      }

      this.utenteObj = {
        UserName: Username,
        Email: Email,
        Nome: Nome,
        Cognome: Cognome,
        Ruolo: Ruolo,
        Gruppi: listIdGruppi,
        ApplicationName: "/",
        UserId: this.isUpdate ? this.utenteForUpdate.UserId : null
      }
      this.callSaveUtente(this.utenteObj)
    }
  }

  /**
   * return lista id of gruppi
   * @param listGruppi 
   */
  getListaId(listGruppi: IGruppo[]): number[] {
    let listIdGruppo: number[] = []
    if (listGruppi && listGruppi.length > 0) {
      listGruppi.forEach(gruppo => {
        listIdGruppo.push(gruppo.Id)
      });
    }
    return listIdGruppo
  }

  /**
   * create or update utente
   * @param utenteObj utenteObj
   */
  callSaveUtente(utenteObj: IUtente) {
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(utenteObj)
    this.utenteService.save(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.alertUtil.showAlert("LBL_NEW_UTENTE_SUCCESS", null, null, null, () => {
            this.ref.close(utenteObj)
          })
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * fetch gruppi by Ruolo
   */
  getGruppiByRuolo(ruolo: IRuolo) {
    let payload = {
      Ruolo: ruolo.Ruolo
    }
    this.gruppi = []
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(payload)
    this.gruppoService.getGruppiByRuolo(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.gruppi = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * fetch all ruoli for dropdown
   */
  getAllRuoli() {
    this.setPayloadRuoli()
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder(this.payloadRuoli)
    this.ruoloService.getAllRuoli(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.ruoli = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  /**
   * set payload for fetch
   */
  setPayloadRuoli() {
    this.payloadRuoli = {
      ApplicationName: "/",
      IsGruppo: true
    }
  }

  /**
   * dropdown Ruolo Clicked
   * @param ruolo 
   */
  onRuoloClicked() {
    this.selectedRuolo = this.utenteForm.controls['Ruolo'].value
    if (this.selectedRuolo) {
      this.getGruppiByRuolo(this.selectedRuolo)
    }
  }

  /**
   * fetch gruppi
   */
  getAllGruppi() {
    this.gruppi = []
    Loading.isLoading = true
    let reqBuilder = new RequestBuilder({})
    this.gruppoService.getAllGruppi(reqBuilder).pipe(finalize(() => {
      Loading.isLoading = false
    })).subscribe(
      response => {
        if (response.data) {
          this.gruppi = response.data
        }
        else if (response.error) {
          let errorKey = "LBL_ERROR_" + response.error.Code
          this.alertUtil.showErrorAlert(errorKey)
          console.log("ERROR: " + response.error.Stack)
        }
        else {
          this.alertUtil.showErrorAlert("LBL_SERVER_ERROR_GENERIC", { error: response.Message })
        }
      },
      error => {
        let errorKey = "LBL_HTTP_ERROR_0"
        if (error.status) {
          errorKey = "LBL_HTTP_ERROR_" + error.status
        }
        this.alertUtil.showErrorAlert(errorKey)
      })
  }

  preCompiledUsername() {
    if (this.utenteForm && this.utenteForm.controls['Username'].value == '' && this.isEditable()) {
      this.utenteForm.controls['Username'].setValue(this.utenteForm.controls['Nome'].value[0] + "." + this.utenteForm.controls['Cognome'].value)
    }
  }

  preCompiledEmail() {
    if (this.utenteForm && this.utenteForm.controls['Email'].value == '' && this.isEditable()) {
      this.utenteForm.controls['Email'].setValue(this.utenteForm.controls['Nome'].value[0].toLowerCase() + "." + this.utenteForm.controls['Cognome'].value.toLowerCase() + "@mail.it")
    }
  }

  isEditable() {
    let editable = false
    if (this.utenteForm.controls['Nome'].value != '' && this.utenteForm.controls['Cognome'].value != '') {
      editable = true
    }
    return editable
  }
}
